import { TransformInt } from '../decorators/transform-int.decorator';

/**
 * Api request filters
 */
export class ApiRequestFilters {
	/**
	 * Free text query string to search records by.
	 */
	query?: string;

	/**
	 * Specific record ids to search for.
	 * @example [1, 2, 3]
	 */
	@TransformInt()
	queryIds?: number[];
}
